import { z } from 'zod'

import { PhoneVerdict } from '~/enums/PhoneVerdict'
import { PhoneNumber } from '~/utils/PhoneNumber'

// Issue text comes from the zod error map, keyed by `phone_rule`; the output is the wire form (national digits).
export const phone = z
  .string()
  .superRefine((value, context) => {
    const { verdict } = PhoneNumber.parse(value)
    if (verdict !== PhoneVerdict.VALID) {
      context.addIssue({ code: 'custom', params: PhoneNumber.ruleParams(verdict) })
    }
  })
  .transform((value) => PhoneNumber.wire(value))
